import { __assign, __rest } from "tslib";
import React from 'react';
import { IconButton } from '@chakra-ui/react';
import { useStorage } from '@companyon/hooks';
export function FAB(props) {
    var rest = __rest(props, []);
    var demoMode = useStorage()[0].demoMode;
    return (React.createElement(IconButton, __assign({ position: "fixed", bottom: demoMode ? undefined : 8, top: demoMode ? '150vw' : undefined, right: 8, zIndex: 999, boxSize: "56px", isRound: true }, rest)));
}
